import { QUOTE_TYPE } from "../../../util/enums";

// Utility function to map project types
export const getProjectTypeDisplayName = (quotetype) => {
    switch (quotetype) {
        case QUOTE_TYPE.NOQUOTE:
            return 'Cost Plus';
        case QUOTE_TYPE.QUOTE:
            return 'Fixed Price Quote';
        default:
            return quotetype; // Return the original value if no match
    }
};